import { Site } from './site';
import { MediaData } from '@noammazuz/vzn-media';

export class Email {
    _id: string;
    name: string;
    subject: string;
    body: string;
    smsContent: string;
    siteId: string;
    mailListId: string;
    site: Site;
    attachments: MediaData[];

    constructor(data) {
        Object.assign(this, data);

        if (data.site) {
            this.site = new Site(data.site);
        }
    }
}